<template>
  <div class="page">
    <div v-if="model != null">
      <van-panel class="panel-info">
        <van-cell slot="header" icon="orders-o" :title="$store.state.OrderTypeEnum.getLabel(model.type)+(model.options?model.options.isExcludeOrderedClerk?'(排除单)':'':'')">
          <van-tag  v-if="model.status == 0" type="danger" size="medium">待接单</van-tag>
          <van-tag v-else-if="model.status == 1" color="#ff976a" size="medium">待开始</van-tag>
          <van-tag v-else-if="model.status == 2" type="primary" size="medium">服务中</van-tag>
          <van-tag v-else-if="model.status == 3" type="success" size="medium">已完成</van-tag>
          <van-tag v-else-if="model.status == -1" size="medium">已取消</van-tag>
        </van-cell>
        <van-cell class="cell-padding" size="large" center :clickable="isAuthority()"
                  :is-link="isAuthority()"
                  :to="isAuthority() ? '/kf/user/detail/'+ model.userId:null"
                  v-if="!(model.type == 'random' && (model.status == -1))&& model.userId != 0">
          <div class="user-item">
            <div class="left align-center">
              <div class="user_head">
                <van-image
                    round
                    width="60px"
                    height="60px"
                    :src="model.headImgUrl">
                </van-image>
                <div class="avatarFrame" v-if="model.levelFrameUrl">
                  <img width="80px" height="80px" :src="model.levelFrameUrl"/>
                </div>
                <van-tag v-if="model.levelName" class="level" type="primary" round size="medium">{{ model.levelName }}</van-tag>
              </div>
              <div class="padding-left-sm">
                <!-- id 已关注 黑名单 -->
                <div class="left-sm-tag">
                  <van-tag plain type="primary">ID：{{ model.userId }}</van-tag>
<!--                  <van-tag v-if="model.subscribe == 1" type="success">已关注</van-tag>-->
<!--                  <van-tag v-else plain>未关注</van-tag>-->
<!--                  <van-tag v-if="$hasFeature('user_violation_share') && model.userViolationSignList && model.userViolationSignList.length > 0" plain color="#91d5ff" @click.stop.prevent="showViolation = true" >-->
<!--                    <a>{{ model.userViolationSignList.length }}条违规</a>-->
<!--                  </van-tag>-->
<!--                  <van-tag v-if="model.isBlacklist" type="default" color="black">黑名单</van-tag>-->
                </div>
                <!-- 用户昵称 1条违规 -->
                <div>
                  <span>{{ model.userName }}</span>
                </div>
                <!-- 推荐人：xxx -->
                <div v-if="model.distributorName" class="recommend">
                  推荐人：{{ model.distributorName }}
                </div>
              </div>
            </div>
            <div class="right">
            </div>
          </div>
        </van-cell>
        <div class="content">
          <!--    用户信息      -->
          <div class="row" style="margin-top: 0" v-if="!(model.type == 'random' && (model.status == -1))">
          </div>
          <div class="row">
            <span class="label">订单号</span>
            <span class="value">{{model.no}}</span>
          </div>
          <div v-if="model.type != 'reward'" class="row">
            <span class="label">订单内容</span>
            <span class="value">
                          {{model.itemCategory != null ? model.itemCategory.name + '-' : ''}}
                          {{model.item.names.join('-')}} × {{model.num}}</span>
          </div>
          <div class="row">
            <span class="label">下单时间</span>
            <span class="value">{{formatDate(model.createTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
            <span v-if="model.status == 0">已等待 {{formatTimeDiff(model.createTime, new Date(), 0)}}</span>
          </div>
          <div v-if="model.status >= 1" class="row">
            <span class="label">接单时间</span>
            <span class="value">{{formatDate(model.confirmTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
            <span v-if="model.status == 1">已等待 {{formatTimeDiff(model.confirmTime, new Date(), 1)}}</span>
          </div>
          <div v-if="model.status >= 2" class="row">
            <span class="label">开始时间</span>
            <span class="value">{{formatDate(model.startTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
            <span v-if="model.status == 2">剩余时长 {{formatTimeDiff(new Date(), model.expectedEndTime, 2)}}</span>
          </div>
          <div v-if="model.status >= 3" class="row">
            <span class="label">结束时间</span>
            <span class="value">{{formatDate(model.endTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div v-if="model.status == -1" class="row">
            <span class="label">取消时间</span>
            <span class="value">{{formatDate(model.cancelTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div v-if="model.type==='reward'&& model.rewardGift" class="row">
            <span class="label">礼物</span>
            <span class="value">{{model.rewardGift.name}} x {{model.num}}</span>
          </div>
          <div v-if="model.type==='reward' && model.blindBoxGift" class="row">
            <span class="label">奖品</span>
            <span class="value">{{model.blindBoxGift.name}}</span>
          </div>
          <div v-if="model.status == -1" class="row">
            <span class="label">取消时间</span>
            <span class="value">{{
                formatDate(model.cancelTime, "YYYY-MM-DD HH:mm:ss")
              }}</span>
          </div>
          <div v-if="model.isContinued != null" class="row">
            <span class="label">是否续单</span>
            <span class="value">
              <van-icon v-if="model.isContinued" name="success" tag="span" color="green" style="height: 20px;line-height: 20px;" />
              <van-icon v-if="!model.isContinued" name="cross" tag="span" color="red" style="height: 20px;line-height: 20px;" />
            </span>
          </div>
          <div v-if="model.guildName" class="row">
            <span class="label">公会名称</span><span class="value">{{model.guildName}}</span>
          </div>
          <div v-if="model.groupName" class="row">
            <span class="label">分组名称</span><span class="value">{{model.groupName}}</span>
          </div>
          <div class="row">
            <span class="label">店员名称</span><span class="value">{{model.clerkName}}</span>
          </div>
          <div v-if="model.type == 'assigned' || model.type == 'reward'" class="row">
            <span class="label">店员性别</span><span class="value">{{$store.state.ClerkSexEnum.getLabel(model.clerkSex)}}</span>
          </div>
          <div class="row">
            <span class="label">订单金额</span><span class="value">￥{{formatPrice(model.totalAmount)}}</span>
          </div>
          <div v-if="model.userCoupon" class="row">
            <span class="label">优惠金额</span>
            <span class="value">￥{{ formatPrice(model.userCoupon.amount) }}</span>
          </div>
          <div class="row">
            <span class="label">实付金额</span><span class="value">￥{{ formatPrice(model.payAmount) }}</span>
          </div>
          <div v-if="model.type == 'random' && model.options != null" class="row">
            <span class="label">买家要求</span>
            <span class="value">
                          <van-tag v-if="model.options.clerkSex != null && model.options.clerkSex != 0" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">{{$store.state.ClerkSexEnum.getLabel(model.options.clerkSex)}}</van-tag>
                          <van-tag v-else-if="model.options.clerkSex === 0" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">不分男女</van-tag>
                          <van-tag v-if="model.options.clerkGrade != null" type="danger" color="#f2826a" plain size="medium" style="margin-right: 3px;margin-bottom: 5px;">{{$store.state.ClerkGradeMap[model.options.clerkGrade]}}</van-tag>
                          <van-tag v-for="(item, index) in model.options.clerkTags" :key="index" plain size="medium" type="danger" color="#f2826a" style="margin-right: 3px;margin-bottom: 5px;">{{item}}</van-tag>
                        </span>
          </div>
          <div class="row">
            <span class="label">店铺备注</span><span class="value">{{model.shopMemo}}</span>
          </div>
          <div class="row">
            <span class="label">买家备注</span><span class="value">{{model.userMemo}}</span>
          </div>

          <div class="row" v-if="model.status != -1 && model.userWechatId && $LeaderPermission.visibleOrderUserInfo.includes('wechat')">
            <span class="label">买家微信</span><span class="value">{{model.userWechatId}}</span>
            <button class="van-button van-button--primary van-button--small" style="height: 20px;line-height: 18px;" v-clipboard="copyUserWechatId" @success="copyCallback(true)" @error="copyCallback(false)">复制微信号</button>
          </div>
          <div class="row" v-if="model.clerkMobile">
            <span class="label">店员手机</span><span class="value">{{model.clerkMobile}}</span>
          </div>
          <div v-if="model.status == -1 && model.refundList" style="display: flex">
            <div style="min-width: 80px;color: #888">退款信息</div>
            <div>
              <div v-for="(item,index) in model.refundList" :key="index">
                <span v-if="item.operatorRole === 'super_admin'">退款人：超级管理员</span>
                <span v-if="item.operatorRole === 'admin'">退款人：管理员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'leader'">退款人：组长-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'kf'">退款人：客服-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'clerk'">退款人：店员-{{item.operatorName}}</span>
                <span v-if="item.operatorRole === 'user'">退款人：用户</span>
                <span v-if="item.operatorRole === 'system'">退款人：系统</span>
                <span v-if="item.refundDesc" style="padding-left: 10px">原因：{{item.refundDesc}}</span>
              </div>
            </div>
          </div>
          <div v-if="model.refundPhotoUrls && model.refundPhotoUrls.length > 0" class="row">
            <span class="label">退款截图</span>
            <div class="screenshot">
              <div class="imgStyle" v-for="(item,index) in model.refundPhotoUrls" :key="index" @click="refundImgClick(index)">
                <img :src="item" class="screenshotImg">
              </div>
            </div>
          </div>
        </div>
      </van-panel>
      <div class="commentBox" v-if="model.photoUrls">
        <div class="row">
          <span class="label">反馈留言</span><span class="value">{{model.content == '' ? '-' : model.content}}</span>
        </div>
        <div class="row">
          <span class="label">反馈截图</span>
          <div class="screenshot">
            <div class="imgStyle" v-for="(item,index) in model.photoUrls" :key="index" @click="imgClick(index)">
              <img :src="item" class="screenshotImg">
            </div>
          </div>
        </div>
      </div>
      <!--  查看违规内容  -->
      <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList" :showRole="'kf'"
                       @changeShowViolation="changeShowViolation"></ViolationSelect>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Panel,
  Cell,
  CellGroup,
  Button,
  Tag,
  Icon,
  Toast,
  Dialog,
  Field,
  Popup,
  RadioGroup,
  Radio,
  ImagePreview,
  Image
} from 'vant';
import Decimal from 'decimal.js';
import moment from 'moment';
import VueClipboards from 'vue-clipboards';
import {getOrder} from '@/api/guilder/order'
import ViolationSelect from '@/components/common/violation-select'
Vue.use(Panel)
    .use(Cell)
    .use(CellGroup)
    .use(Button)
    .use(Tag)
    .use(Icon)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Popup)
    .use(RadioGroup)
    .use(Radio)
    .use(Image)

Vue.use(VueClipboards);

export default {
  name: 'admin-order-detail',
  components: {
    ViolationSelect
  },
  data () {
    return {
      showViolation:false,
      orderId: this.$route.params.id,
      model: null,
      payAmount: null,
      msg: null,
    }
  },
  computed: {
    copyUserWechatId() {
      if (this.model) {
        return this.model.userWechatId;
      }
      return null;
    }
  },
  methods: {
    //判断权限
    isAuthority(){
      return false
    },
    changeShowViolation(val){
      this.showViolation = val
    },
    // 格式化时间差
    formatTimeDiff(start, end, status) {
      start = moment(start)
      end = moment(end)
      const diffSeconds = end.diff(start, 'seconds')
      if (status === 2 && diffSeconds < 1) {
        return '即将完成'
      }
      if (diffSeconds < 60) {
        return `${diffSeconds}秒`
      }
      const diffMinutes = end.diff(start, 'minutes')
      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`
      }
      const diffHours = end.diff(start, 'hours')
      if (diffHours < 24) {
        return `${diffHours}小时`
      }
      const diffDays = end.diff(start, 'days')
      return `${diffDays}天`
    },
    copyCallback(success) {
      if (success) {
        Toast('复制成功');
      } else {
        Toast('复制失败，请长按文本复制');
      }
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getOrder(
          this.orderId).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.model = data.order;
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    refundImgClick(i){
      ImagePreview({
        images: this.model.refundPhotoUrls,
        startPosition: i,
      })
    },
    imgClick(i){
      ImagePreview({
        images: this.model.photoUrls,
        startPosition: i,
      })
    }
  },
  mounted() {
    this.loadData()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.page {
  padding-bottom: 100px;

  .panel-info {
    margin-top: 10px;
    .cell-padding {
      padding: 5px 15px 10px;
      .user-item {
        display: flex;
        align-items: center;
        .userMemo {
          color: #999;
        }
        .left {
          flex: 1;
          display: flex;
          .service-info {
            color: #333;
          }
          .created {
            color: #555;
            margin-bottom: 5px;
          }
          .user_head {
            position: relative;
            padding: 10px;
            .avatarFrame {
              position: absolute;
              top: 0;
              left: 0;
            }
            .level {
              position: absolute;
              left: 50%;
              height: 10px;
              font-size: 10px;
              white-space: nowrap;
              bottom: 0px;
              transform: translateX(-50%);
            }
          }
          .padding-left-sm div span{
            margin-right: 4px;
          }
          .recommend{
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #999999;
          }
        }
        .right {
          text-align: right;
          min-width: 30px;
          .total-amount {
            color: #333;
          }
        }
      }
    }

    .content {
      font-size: 14px;
      padding: 0 15px 10px;
    }
  }
  .recommend{
    padding-top: 3px;
    font-size: 12px;
    color: #999999;
  }
  .id-box{
    padding-bottom: 5px;
  }
  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }
  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }
  .commentBox{
    width: 100%;
    background: #fff;
    padding: 15px;
    margin: 20px 0;
    box-sizing: border-box;
  }
  .imgStyle{
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }
  .screenshot{
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }
  .screenshotImg{
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

</style>
